export const routes = [
  {
    path: '/cidade/:id/acompanhamento',
    component: () => import(/* webpackChunkName: "attendance" */ './components/List'),
    name: 'city.attendance.list',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cidade/:id/acompanhamento/obter/:acompanhamento',
    component: () => import(/* webpackChunkName: "attendance" */ './components/Get'),
    name: 'city.attendance.get',
    meta: {
      requiresAuth: true
    }

  }
]
